import {Modal} from 'bootstrap';
import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {PermissionsService} from '../../../../Services/permissions.service';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {PreferencesService} from '../../../../Services/preferences.service';
import {ResponseModel} from '../../../../DataModels/response-model';

// Data model representing a single suggested item to order
interface ItemsToOrderItem {
  item_id: any;
  item_name: string;
  quantity: number;
  quantity_on_hand: number;
  quantity_on_po: number;
  minimum_on_hand_quantity: number;
  maximum_on_hand_quantity: number;
  minimum_order_quantity: number;
  include?: boolean;
}

@Component({
  selector: 'app-modal-items-to-order',
  templateUrl: './modal-items-to-order.component.html',
  styleUrls: ['./modal-items-to-order.component.css'],
  standalone: false
})
export class ModalItemsToOrderComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;
  public pref: any;

  @Output() getItemsToOrderEmit = new EventEmitter<string>();
  @Output() gItemsToOrderEmit = new EventEmitter<string>();
  @Output() onCloseEmit = new EventEmitter<string>();

  locations = [];

  constructor(public p: PermissionsService,
              public pre: PreferencesService,
              public tableDataService: DataService,
              public localStorage: StorageService,
              public datePipe: DatePipe,
              private router: Router) {
  }

  ngOnInit() {
    // this.pref = this.pre.ListPreferences();
    if (!this.vm.itemsToOrder) {
      this.vm.itemsToOrder = [];
    }

    if (!this.vm.request.location_id) {
      this.loadLocations();
    }
  }

  onCloseModal() {
    this.onCloseEmit.emit();
  }

  loadLocations() {
    this.tableDataService.getData('location', '?pageNumber=0&pageSize=999999&linkedEntityType=ap').subscribe((result: ResponseModel) => {
      this.vm.location = result.Data;
    });
  }

  getItemToOrderProcess() {

    const d = this.datePipe.transform(new Date(), 'MM/dd/yyyy');

    // Reset state
    this.vm.itemsToOrder = [];
    this.vm.noItemsToOrder = false;
    setTimeout(() => {
      this.vm.buttonsDisabled = true;
    }, 500);

    // Ensure required request params
    if (!this.vm.request.company_id) {
      this.vm.request.company_id = this.pre.LoadByLocalStorage('default_company_id');
    }
    if (!this.vm.request.location_id && this.vm?.item?.header?.location_id) {
      this.vm.request.location_id = this.vm.item.header.location_id;
    }

    // Single endpoint to fetch suggested items to order
    const params = this.encodeQueryData({
      location_id: this.vm.request.location_id,
      company_id: this.vm.request.company_id,
      toDate: d,
      pageNumber: 0,
      pageSize: 999999
    });

    // console.log('params: ' + params);
    this.tableDataService.getData('ItemQuantity/reorder', '?' + params)
      .subscribe({
        next: (result: ResponseModel) => {
          const data = (result && (result as any).Data ? (result as any).Data : result) as ItemsToOrderItem[];
          const normalized: ItemsToOrderItem[] = (data || []).map((row: any) => ({
            item_id: row.item_id,
            item_name: row.item_name,
            quantity: Number(row.quantity || 0),
            quantity_on_hand: Number(row.quantity_on_hand || 0),
            quantity_on_po: Number(row.quantity_on_po || 0),
            minimum_on_hand_quantity: Number(row.minimum_on_hand_quantity || 0),
            maximum_on_hand_quantity: Number(row.maximum_on_hand_quantity || 0),
            minimum_order_quantity: Number(row.minimum_order_quantity || 0),
            include: row.include === undefined ? true : !!row.include,
          }));

          this.vm.itemsToOrder = normalized;
          this.vm.noItemsToOrder = this.vm.itemsToOrder.length === 0;
          this.vm.buttonsDisabled = false;
        },
        error: (_err) => {
          // On error, stop spinner and indicate no items
          this.vm.itemsToOrder = [];
          this.vm.noItemsToOrder = true;
          this.vm.buttonsDisabled = false;
        }
      });
  }

  getItemsToOrder() {
    //  console.log('in get: ' + this.vm.getItemsToOrderEmit);
    if (!this.vm.getItemsToOrderEmit) {
      this.getItemToOrderProcess();
    } else {
      this.getItemsToOrderEmit.emit();
    }
  }

  generateItemsToOrder() {
    // console.log('in generate: ' + this.vm.gItemsToOrderEmit);
    if (!this.vm.gItemsToOrderEmit) {
      // console.log('in generate = co: ' + this.vm.request.location_id + ' - loc:' + this.vm.request.location_id );
      // get ent name
      let entName = '';
      let coId = '';
      let entId = '';

      this.vm.location.forEach((element, index, array) => {
        if (element.id === this.vm.request.location_id) {
          entName = element.entity_name;
          entId = element.entity_id;
          coId = element.company_id;
        }
      });
      // console.log('in orders to generate: ' +  JSON.stringify(this.vm.itemsToOrder));
      // these get removed by the PO form opening below
      localStorage.setItem('itemsToOrderCompanyId', coId);
      localStorage.setItem('itemsToOrderEntityName', entName);
      localStorage.setItem('itemsToOrderEntityId', entId);
      localStorage.setItem('itemsToOrderLocationId', this.vm.request.location_id);
      localStorage.setItem('itemsToOrder', JSON.stringify(this.vm.itemsToOrder));

      this.router.navigate(['/transactions/invoice/po/form'], {queryParams: {invoiceId: 'newPurchaseOrder'}});

      // this.getItemsToOrderEmit.emit(this.vm.itemsToOrder);

    } else {
      // console.log('in else = co: ' + this.vm.request.location_id + ' - loc:' + this.vm.request.location_id + ' - data:' + JSON.stringify(this.vm.itemsToOrder));
      this.gItemsToOrderEmit.emit(JSON.stringify(this.vm.itemsToOrder));
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      } else if (data[d] != null && data[d] == '') {
        ret.push(encodeURIComponent(d) + '=');
      }
    }
    return ret.join('&');
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
